<template>
  <div class="head-nav">
    <div class="nav-content">
      <div class="nav-content-one " style="flex-wrap:wrap;">
        <div @click="go(item)" class="c-c  h100 d van-hairline--bottom" :class="(index != 4 && index !=9 && index !=14) ? 'van-hairline--right' : ''" v-for="(item, index) in nav" :key="index">
          <img class="h-img" :src="item.thumb_url? item.thumb_url: 'http://cdn11.jfbst.com/statics/toutiao.png'" alt>
          <span>{{ item.title }}</span>
        </div>
      </div>
    </div>
    <div class="nav-content-bottom van-hairline--top">
      <div class="nav-content-bottom-left c-c h100 f10">
          <div class="flex1">
              <span>累计用户：</span>
              <span>{{ times.users }}</span>
          </div>
          <div class="flex1">
              <span>累计帖子：</span>
              <span>{{ times.messages_total}}</span>
          </div>
          <div class="flex1">
              <span>今日帖子：</span>
              <span>{{times.messages_today }}</span>
          </div>
      </div>
      <div class="nav-content-bottom-right c-c f13" @click="help()">更多</div>
    </div>
  </div>
</template>

<script>
import { Dialog } from "vant";
import { getData } from '../Interface/http';
export default {
  name: "HeadNav",
  data() {
    return {
      list:[],
      helpMes: {}
    }
  },
  methods:{
    go(index){
      if(index.url.includes('http')) {
        if (!index.url.includes("jfbst.com")) {
          Dialog.confirm({
            message:
              "您将进入第三方平台。相关服务和责任将由该第三方承担。如有问题请咨询该平台客服",
          }).then(() => {
            window.location.href = index.url;
          });
        } else {
          window.location.href = index.url;
        }
        return;
      }
      if(index.type == 19) {
        this.$router.push({
          path: index.url
        })
        return;
      }
      this.$store.commit('UPDATEATBINDEX',{tag: 10});
      this.$store.commit('UPDATEABOUTMESSAGE',{aboutMessage: index});
      // this.$router.push({ path: 'about', params: { mes: index }})
      this.$router.push({ path: '/about', query: { id: index.id, title: index.title,active: -1 }})
    },
    getHelp(){
      getData('/article/help').then(res=>{
        this.helpMes = res.data;
      })
    },
    help(){
      this.$store.commit('UPDATEATBINDEX',{tag: -1});
      // this.$store.commit('UPDATEARTICLEDETAIL',{articleDetail: this.helpMes});
       this.$router.push({ name: "helpPage"});
    }
  },
  mounted(){
    this.getHelp();
  },
  props:[
    'nav',
    'times'
  ]
};
</script>

<style scoped>
.head-nav {
  width: 100%;
  margin-bottom: -7px;
  /* height: 195px; */
  position: relative;
  top: -12px;
}
.nav-content {
  width: 355px;
  margin: 0 auto;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}
.nav-content-one {
  flex: 1;
  width: 100%;
  display: flex;
  align-items: center;
}
.nav-content-bottom {
  width: 355px;
  height: 32px;
  background: #fff;
  margin: 0 auto;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
  position: relative;
  padding-right: 55px;
  box-sizing: border-box;
}
.nav-content-bottom-right {
  width: 55px;
  height: 32px;
  position: absolute;
  top: 0;
  right: 0;
}
.h-img {
    width: 39px;
    height: 39px;
}
.d {
    flex-direction: column;
    font-size: 12px;
    color: rgb(50, 51, 51);
    height: 81px;
    width: 71px;
}
.d span{
  margin-top: 6px;
}
</style>
